const enCommon = require("./en/common.json");
const deCommon = require("./de/common.json");
const frCommon = require("./fr/common.json");
const esCommon = require("./es/common.json");
const ptCommon = require("./pt/common.json");
const ruCommon = require("./ru/common.json");
const jaCommon = require("./ja/common.json");
const zhCommon = require("./zh/common.json");
const koCommon = require("./ko/common.json");
const itCommon = require("./it/common.json");
const ukCommon = require("./uk/common.json");
const plCommon = require("./pl/common.json");
const nlCommon = require("./nl/common.json");
const svCommon = require("./sv/common.json");

const resources = {
    en: { common: enCommon },
    de: { common: deCommon },
    fr: { common: frCommon },
    es: { common: esCommon },
    pt: { common: ptCommon },
    ru: { common: ruCommon },
    ja: { common: jaCommon },
    zh: { common: zhCommon },
    ko: { common: koCommon },
    it: { common: itCommon },
    uk: { common: ukCommon },
    pl: { common: plCommon },
    nl: { common: nlCommon },
    sv: { common: svCommon }
};

const supportedLocales = Object.keys(resources);
const namespaces = ["common"];
const defaultLocale = "en";

module.exports = {
    resources,
    supportedLocales,
    namespaces,
    defaultLocale
};
